import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';

const LandingPage: React.FC = () => {
    useEffect(() => {
        document.title = 'חיים פלוס - מחשבון הוספת שנות חיים';
    }, []);

    return (
        <div className="container landing-page-container">
            <a href="#main-content" className="skip-link">דלג לתוכן הראשי</a>
            <header>
                <div className="logo">
                    <img
                        src="/assets/life-logo.svg"
                        alt="חיים פלוס"
                    />
                </div>
            </header>
            <main id="main-content">
                {/* Top Section: Hero Text */}
                <div className="hero-text-section">
                    <h1 className="subtitle">
                        חיים ארוכים ובריאים יותר – מתחילים כאן.
                        <br />
                        כמה שנים בריאות נוספות תוכלו להעניק לעצמכם?
                    </h1>
                    <p className="description">
                        גלו כיצד תוכלו להוריד את הסיכוי לאירועים לבביים ומוחיים בעזרת חישוב מספר נתונים בודדים.
                    </p>
                    <Link to="/calculator" className="start-btn">
                        <span className="btn-text">אפשר להתחיל</span>
                    </Link>
                </div>

                {/* Image - positioned left on desktop/tablet, below button on mobile */}
                <img
                    src="/assets/home-img_2.png"
                    alt="איור של אנשים רצים, מסמל חיים בריאים ופעילות גופנית"
                    className="landing-page-image"
                />
            </main>

            {/* Bottom Section: Footer */}
            <Footer />
        </div>
    );
};

export default LandingPage;
